import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  container?: Element | DocumentFragment;
}

const Portal: React.FC<PortalProps> = ({ children, container }) => {
  // Use provided container or default to document.body
  const portalContainer = container || document.body;
  
  return createPortal(children, portalContainer);
};

export default Portal;